import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { playGame, gameResults } from "@/lib/stage";

export function GamePlay({ post, onSignIn }) {
  const { user } = useAuth();
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { gameResults(post.id).then(setRes).catch(() => {}); }, [post.id]);

  const pick = async (i) => {
    if (!user) return onSignIn();
    setBusy(true);
    try { setRes(await playGame(post.id, i)); } finally { setBusy(false); }
  };
  const total = res?.total || 0;
  const answered = res?.my_option != null;
  return (
    <div className="p-4 border-b border-white/10" data-testid="stage-game">
      <div className="text-[10px] uppercase tracking-widest text-neutral-500">Play · {total} {total === 1 ? "player" : "players"}</div>
      <div className="mt-1 font-bold">{post.game.question}</div>
      <div className="mt-3 space-y-2">
        {post.game.options.map((o, i) => {
          const n = res?.counts?.[i] || 0;
          const pct = total ? Math.round((n / total) * 100) : 0;
          const correct = res?.correct_index === i;
          const mine = res?.my_option === i;
          return (
            <button key={i} type="button" disabled={busy || answered} onClick={() => pick(i)} data-testid={`stage-game-option-${i}`}
              className={`relative w-full overflow-hidden rounded-xl border px-3 py-2 text-left text-sm transition-colors ${mine ? "border-white" : "border-white/15 hover:border-white/40"} ${correct ? "border-[#34C759]" : ""}`}>
              {answered && <span className="absolute inset-y-0 left-0 bg-white/10" style={{ width: `${pct}%` }} />}
              <span className="relative flex justify-between"><span>{o}</span>{answered && <span className="font-mono text-neutral-400">{pct}%</span>}</span>
            </button>
          );
        })}
      </div>
      {answered && res?.won != null && (
        <div className={`mt-3 flex items-center gap-2 text-sm font-semibold ${res.won ? "text-[#34C759]" : "text-neutral-400"}`} data-testid="stage-game-outcome">
          <Trophy className="h-4 w-4" />{res.won ? `You got it! ${res.reward_text || ""}` : "Not this time — stay in the audience for the next round."}
        </div>
      )}
      {answered && res?.won == null && post.game.reward_text && <div className="mt-3 text-xs text-neutral-400">Prize: {post.game.reward_text}</div>}
    </div>
  );
}
